import {Types} from 'Modules/ContractModule';
import {ContractActionModel} from "Redux/Actions/Models/ContractActionModel";
import * as ActionTypes from "Redux/Actions/EnumTypes/ActionEnumTypes";

export type State = Types.ContractStore;
export const ContractListInitialState = {
    contractList: [],
    contractHistory: [],
    contractNumberActive: null,
    currentVin: null
};

export function contractReducer(state: State = ContractListInitialState, action: ContractActionModel): State {
    switch (action.type) {
        case ActionTypes.CONTRACT.GET_CONTRACT_LIST_SUCCESS: {
            return {
                ...state,
                contractList: [...state.contractList, ...action.payload.contractList]
            };
        }
        case ActionTypes.CONTRACT.GET_CONTRACT_LIST_WITH_FILTERS_SUCCESS: {
            return {
                ...state,
                contractList: action.payload.contractList
            };
        }
        case ActionTypes.CONTRACT.GET_CONTRACT_HISTORY_SUCCESS: {
            return {
                ...state,
                contractHistory: action.payload.contractHistory
            };
        }
        case ActionTypes.CONTRACT.SET_ACTIVE: {
            return {
                ...state,
                contractNumberActive: action.payload.contractNumber
            };
        }
        case ActionTypes.CONTRACT.SET_CURRENT_CONTRACT_VIN: {
            return {
                ...state,
                currentVin: action.payload.currentVin
            };
        }
        default: {
            return {
                ...state
            };
        }
    }
}



// WEBPACK FOOTER //
// ./src/Redux/Reducers/ContractReducer.ts